import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, loadAnalytics } from "@/lib/consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === "accepted") loadAnalytics();
    else if (!c) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("mat:cookie-preferences", reopen);
    return () => window.removeEventListener("mat:cookie-preferences", reopen);
  }, []);

  const aceitar = () => { setConsent("accepted"); loadAnalytics(); setVisible(false); };
  const recusar = () => { setConsent("denied"); setVisible(false); };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[90]"
          role="dialog"
          aria-label="Aviso de cookies"
        >
          <div className="bg-white border border-maternnia-nevoa/70 rounded-2xl shadow-[0_18px_48px_rgba(43,37,38,0.16)] p-5">
            <div className="flex items-start gap-3">
              <span className="h-9 w-9 rounded-xl bg-maternnia-porcelana flex items-center justify-center shrink-0">
                <Cookie size={18} className="text-maternnia-eucalipto" />
              </span>
              <div>
                <p className="text-sm text-maternnia-charcoal font-medium">Usamos cookies</p>
                <p className="mt-1 text-xs text-maternnia-taupe font-light leading-relaxed">
                  Usamos cookies de análise para entender como o site é usado e melhorar sua experiência.
                  Você pode aceitar ou recusar. Saiba mais na{" "}
                  <Link to="/privacidade" className="text-maternnia-eucalipto underline underline-offset-2">Política de Privacidade</Link>.
                </p>
              </div>
            </div>
            <div className="mt-4 flex items-center gap-2.5">
              <button
                data-testid="cookie-aceitar"
                onClick={aceitar}
                className="flex-1 bg-maternnia-eucalipto text-white hover:bg-maternnia-floresta rounded-full px-4 py-2.5 text-sm font-medium transition-colors"
              >
                Aceitar
              </button>
              <button
                data-testid="cookie-recusar"
                onClick={recusar}
                className="flex-1 border border-maternnia-nevoa text-maternnia-charcoal hover:bg-maternnia-porcelana/60 rounded-full px-4 py-2.5 text-sm font-medium transition-colors"
              >
                Recusar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
